import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const useActiveTabs = () => {
  const [activeTab, setActiveTab] = useState<number>(0);
  const navigate = useNavigate();
  const handleChange = (
    event: React.SyntheticEvent | null,
    newValue: number,
    url?: string
  ): void => {
    setActiveTab(newValue);
    if (url) {
      navigate(url, { replace: true });
    }
  };

  return { activeTab, handleChange };
};
